export function timeout(milliseconds: number = 0) {
  return function(_target: any, _key: any, descriptor: TypedPropertyDescriptor<any>) {

    const originalMethod = descriptor.value;

    descriptor.value = function(...args: any) {
      setTimeout(() => {
        originalMethod.apply(this, args);
      }, milliseconds);
    };

    return descriptor;
  };
}

export function stopClickBubbling() {
  return function(_target: any, _key: any, descriptor: TypedPropertyDescriptor<any>) {

    const originalMethod = descriptor.value;

    descriptor.value = function(...args: any) {
      originalMethod.apply(this, args);
      return false; // stop propagation by attaching false value in return.
    };

    return descriptor;
  };
}
